import * as React from "react";
import { ZoomIn } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
const certifications = [{
  id: 1,
  title: "ISCC EU Certified",
  description: "International Sustainability and Carbon Certification for the circular economy and bioeconomy, ensuring sustainable supply chains.",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/iscc_eu_certification_logo.png",
  fullImage: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/iscc_eu_certificate_document.png"
}, {
  id: 2,
  title: "ISO 9001:2015",
  description: "International standard for quality management systems, demonstrating our commitment to consistent quality and customer satisfaction.",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/iso_9001_quality_logo.png",
  fullImage: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/iso_9001_certificate_document.png"
}, {
  id: 3,
  title: "ISO 14001:2015",
  description: "Environmental management system certification, reflecting our dedication to minimizing environmental impact in maritime logistics.",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/iso_14001_environmental_logo.png",
  fullImage: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/iso_14001_certificate_document.png"
}, {
  id: 4,
  title: "RSPO Member",
  description: "Roundtable on Sustainable Palm Oil membership, supporting the growth and use of sustainable palm oil products.",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/rspo_sustainability_logo.png",
  fullImage: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/rspo_certificate_document.png"
}];
export default function VerifiedQualityStandards() {
  return;
}